module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Egliswil-7ae050fdf27678fae1e06b2836d419df.svg";